import { RSAffiliation } from '@/api/apis/resources';
import { CONTRACTOR_AFFILIATION_NAMES } from '@/constants/user.constants';
import { getLocationAddress } from '@/utils/helpers';
import { useCountriesData } from '@/contexts/CountriesDataProvider';

export const Affiliation = ({ affiliationData }: { affiliationData?: RSAffiliation }) => {
  const { resolveSubdivisionName } = useCountriesData();

  if (!affiliationData) return null;

  const { type, entityName, entityLocation } = affiliationData;

  return (
    <div className="text-m-r">
      <div>{CONTRACTOR_AFFILIATION_NAMES[type]}</div>
      <div>{entityName}</div>
      {entityLocation && <div>{getLocationAddress(entityLocation, resolveSubdivisionName)}</div>}
    </div>
  );
};
